import { createElement } from "react";
import { createRoot } from "react-dom/client";

import RequestForm from "./components/RequestForm";
import PartnerForm from "./components/PartnerForm";
import PartnerNote from "./components/PartnerNote";
import LoadingExperience from "./components/LoadingExperience";
import DemoShowcase from "./components/demo/DemoShowcase";
import AovAuditForm from "./components/audit/AovAuditForm";
import AovAuditExperience from "./components/audit/AovAuditExperience";
import AovAuditReport from "./components/audit/AovAuditReport";

const REGISTRY = { RequestForm, PartnerForm, PartnerNote, LoadingExperience, DemoShowcase, AovAuditForm, AovAuditExperience, AovAuditReport };

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-react-component]").forEach((node) => {
    const Component = REGISTRY[node.dataset.reactComponent];
    if (!Component) return;
    const props = node.dataset.props ? JSON.parse(node.dataset.props) : {};
    createRoot(node).render(createElement(Component, props));
  });
});
